import Constants from "expo-constants";
const { manifest } = Constants;
import { localStorage } from './../../../utils/localStorage';


const BASE_URL =
    // 'http://localhost:3000'
    'https://calm-mesa-16511.herokuapp.com'
;

// const authEndpoint = `http://${manifest.debuggerHost.split(':').shift()}:3000/auth_poall/sign-in`;
// const authEndpoint = 'https://calm-mesa-16511.herokuapp.com/auth_poall/register-user';

const authEndpoint =  BASE_URL + '/auth_poall/sign-in';



export let authToken = undefined;
export let user_id = undefined;
export let user_object = undefined;
export const AUTH_TOKEN_STORAGE_KEY = 'auth-token';
export const USER_ID_STORAGE_KEY = 'user-id';
export const USER_OBJ_STORAGE_KEY = 'user-obj';

export async function getAuthToken(data = {}) {
    console.log(`authEndpoint ${authEndpoint}, data`, data);
    try {
        const response = await fetch(authEndpoint, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(data),
        });
        console.log('const response = await fetch(authEndpoint, {', response);
        const jsonData = await response.json(); // parses response to JSON
        console.log('const jsonData = await response.json()', response);

        if (jsonData.error && jsonData.error.length > 0) {
            /*  this will return an object, ie:
                {   
                    error: "Unauthorized"
                    message: "Invalid email or password"
                    statusCode: 401
                }
            */
            return jsonData;
        }
        else {
            /*  this will return an object like: 
                {
                    jwt_token: "<string: token value>"
                    refetch_token: "<string: token value>"
                    user_id: <int: user id>
                }
            */
            console.log('====> [GraphQl] ===> Token returned = ', jsonData);
            authToken = jsonData.jwt_token;
            user_id = jsonData.user_id;
            user_object = jsonData.user;
            await setAuthTokenInStorage(authToken);
            await setUserObjectInStorage(jsonData.user);
            return jsonData;
        }
    }
    catch (error) {
        console.log('there was an error thrown in getAuthToken', error);
    }
}

export async function resetAuthToken() {
    await removeAuthTokenInStorage();
    authToken = undefined;
}

export async function resetUserObject() {
    await removeUserObjectInStorage();
    user_object = undefined;
}



export async function hydrateTokenFromLocalStorage(tokenPassed: string): Promise<boolean> {
    if (tokenPassed) {
        authToken = tokenPassed;
        if (tokenPassed && authToken === tokenPassed) {
            console.log('hydrateTokenFromLocalStorage SUCCESS');
            return true;
        }
    }
    else {
        console.log('looking for token in storage');
        const token: string = await getUserObjectFromStorage();
        authToken = token;
        if (token && authToken === token) {
            console.log('hydrateTokenFromLocalStorage SUCCESS');
            return true;
        }
    }

    return false;
}

export async function hydrateUserObjectFromLocalStorage(userPassed: any): Promise<boolean> {
    try {
        if (typeof userPassed === 'string') {
            user_object = JSON.parse(userPassed);
            if (user_object) {
                console.log('hydrateTokenFromLocalStorage SUCCESS');
                return true;
            }
        }
        else if (typeof userPassed === 'object') {
            user_object = userPassed;
            if (user_object) {
                console.log('hydrateTokenFromLocalStorage SUCCESS');
                return true;
            }
        }
        else {
            console.log('looking for token in storage');
            const userFromStorage: string = await getUserObjectFromStorage();
            user_object = userFromStorage;
            if (user_object) {
                console.log('hydrateTokenFromLocalStorage SUCCESS');
                return true;
            }
        }
    }
    catch (error) {
        console.log(error);
    }
    

    return false;
}



// local storage: setters
export async function setAuthTokenInStorage(token: string): Promise<boolean> {
    const tokenSet = await localStorage.setItem(AUTH_TOKEN_STORAGE_KEY, token);
    console.log('====> [LocalStorage] ===> setAuthTokenInStorage = ', { tokenSet, token });
    return tokenSet;
}
export async function setUserObjectInStorage(user: any): Promise<boolean> {
    const userStored = await localStorage.setItem(USER_OBJ_STORAGE_KEY, JSON.stringify(user));
    console.log('====> [LocalStorage] ===> setUserInStorage = ', { userStored, user });
    return userStored;
}

// local storage: getters
export async function getAuthTokenFromStorage(): Promise<string> {
    const token: string = await localStorage.getItem(AUTH_TOKEN_STORAGE_KEY);
    console.log('====> [LocalStorage] ===> getAuthTokenFromStorage = ', token);
    return token;
}
export async function getUserObjectFromStorage(): Promise<any> {
    const user: string = await localStorage.getItem(USER_OBJ_STORAGE_KEY);
    console.log('====> [LocalStorage] ===> getUserObjectFromStorage = ', user);
    if (user) {
        const userObjectFromStorage: any = JSON.parse(user);
        console.log('============================================================================== userObjectFromStorage', userObjectFromStorage)
        return userObjectFromStorage;
    }
    else {
        return user;
    }
}

// local storage: removals
export async function removeAuthTokenInStorage(): Promise<boolean> {
    const itemRemoved = await localStorage.removeItem(AUTH_TOKEN_STORAGE_KEY);
    console.log('====> [LocalStorage] ===> removeAuthTokenInStorage = ', itemRemoved);
    return itemRemoved;
}

export async function removeUserObjectInStorage(): Promise<boolean> {
    const itemRemoved = await localStorage.removeItem(USER_OBJ_STORAGE_KEY);
    console.log('====> [LocalStorage] ===> removeUserObjectInStorage = ', itemRemoved);
    return itemRemoved;
}
